var React = require('react');

function Quotes (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"","fillRule":"evenodd"},React.createElement("path",{"d":"M28.694 16.118c7.518 0 9.405 5.321 9.405 9.222 0 4.912-3.538 8.812-8.773 8.812-5.519 0-9.34-4.334-9.34-10.112 0-10.402 5.881-16.672 17.202-24.04 0 0-8.069 9.617-8.494 16.118M8.7083 16.118c7.518 0 9.405 5.321 9.405 9.222 0 4.912-3.538 8.812-8.773 8.812-5.519 0-9.34-4.334-9.34-10.112 0-10.402 5.881-16.672 17.202-24.04 0 0-8.069 9.617-8.494 16.118"})));
}

Quotes.defaultProps = {"width":"39","height":"35"};

module.exports = Quotes;

Quotes.default = Quotes;
